<template>
    <div class="nav-bar" v-on:click.self="closePolicyMenu" id="navBox">
        <router-link :to="{ name: 'Home' }" class="home-header" >
            <img src="../assets/RoundForWeb.png" class="logo-link">
            <span>Callum Hill Software</span>
        </router-link>

        <div id="nav-links">
            <router-link @click="closePolicyMenu" :to="{ name: 'Home' }">Home</router-link>
            <router-link @click="closePolicyMenu" :to="{ name: 'ProjectDetails', params: { appName: 'brew-tracker' }}">Brew Tracker</router-link>
            <router-link @click="closePolicyMenu" :to="{ name: 'ProjectDetails', params: { appName: 'rain-tracker' }}">Rain Tracker</router-link>
            <router-link @click="closePolicyMenu" :to="{ name: 'ProjectDetails', params: { appName: 'bean-tracker' } }">Bean Tracker</router-link>
            <router-link @click="closePolicyMenu" :to="{ name: 'Contact' }">Contact</router-link>
            <a @click="togglePolicyMenu"><span>Policies T&Cs</span><i class="arrow down"></i></a> 
        </div>
        <div class="dropdown-wrapper" id="drop-down-id">
            <div class="dropdown" v-show="policyMenuOpen" >
                <router-link :to="{ name: 'PrivacyPolicy', params: { appName: 'brew-tracker' }}" >
                    Brew Tracker Privacy Policy
                </router-link>
                <router-link :to="{ name: 'PrivacyPolicy', params: { appName: 'rain-tracker' }}" >
                    Rain Tracker Privacy Policy
                </router-link>
                <router-link :to="{ name: 'PrivacyPolicy', params: { appName: 'bean-tracker' }}" >
                    Bean Tracker Privacy Policy
                </router-link>
                <router-link :to="{ name: 'TermsConditions', params: { appName: 'brew-tracker' }}" >
                    Brew Tracker Terms & Conditions
                </router-link>
                <router-link :to="{ name: 'TermsConditions', params: { appName: 'rain-tracker' }}" >
                    Rain Tracker Terms & Conditions
                </router-link>
                <router-link :to="{ name: 'TermsConditions', params: { appName: 'bean-tracker' }}" >
                    Bean Tracker Terms & Conditions
                </router-link>
            </div>
        </div>
    </div>
    <div class="nav-bar-spacer" id="nav-bar-spacer"></div>
    <router-view @click="closePolicyMenu" />
</template>

<script>

export default {
    data() {
        return {
            policyMenuOpen: false,
            navBarHeight: 60
        } 
    },
    mounted() {
        window.addEventListener("load", onLoadFunction);

        function onLoadFunction(e)
        {
            onResizeFunction();
            window.addEventListener("resize", onResizeFunction);
        }

        function onResizeFunction (e)
        {
            const top = document.getElementById('navBox').offsetHeight;
            const dropDown = document.getElementById('drop-down-id');
            if(dropDown != null)
            {
                dropDown.setAttribute("style", "top:" + top + "px");
            }
            const spacer = document.getElementById('nav-bar-spacer');
            if(spacer != null)
            {
                spacer.setAttribute("style", "height:" + top + "px");
            }
        }
    },
    methods:{
        togglePolicyMenu()
        {
            this.policyMenuOpen = !this.policyMenuOpen
        },
        closePolicyMenu()
        {
            if(this.policyMenuOpen)
                this.policyMenuOpen = false
        }
    }
}
</script>

<style>
.nav-bar
{
    position: fixed;
    top: 0;
    width: 100%;
    min-height: 60px;
    background-color: white; 
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    padding-left: 1rem;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: space-between;
}

.nav-bar-spacer
{
    width: 100%;
    height: 60px;
}

.home-header
{
    display: flex;
    cursor: pointer;
    font-weight: bold;
    font-size: 22px;
    column-gap: 1rem;
    text-decoration: none;
    color: var(--blackish);
}

.home-header .logo-link
{
    max-width: 45px;
    max-height: 45px;
}
.home-header > span
{
    display: flex;
    align-items: center;
}
#nav-links
{
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    column-gap: 1rem;
    padding-right: 3rem;
    row-gap: 0.5rem;
}

#nav-links a, .dropdown a
{
    font-size: 18px;
    font-weight: bold;
    color: black;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 0.3rem;
}

#nav-links a.router-link-exact-active, .dropdown a.router-link-exact-active
{
    /* color: var(--primary); */
    text-decoration: underline 2px;
    text-underline-offset: 0.2em;
}

.dropdown-wrapper
{
    position: fixed;
    right: 0;
    top: 60px;
}
.dropdown
{
    background: white;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    padding: 1rem;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    text-decoration: none;
    align-items: flex-end;
    border-bottom-left-radius: 20px;
}


</style>